// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import InsertTextController from "./insert_text_controller"
application.register("insert-text", InsertTextController)

import FragmentFocusController from "./fragment_focus_controller"
application.register("fragment-focus", FragmentFocusController)

import TextPreprocessController from "./text_preprocess_controller"
application.register("text-preprocess", TextPreprocessController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import BrowserOcrExperimentController from "./browser_ocr_experiment_controller"
application.register("browser-ocr-experiment", BrowserOcrExperimentController)

import TurboFeedbackController from "./turbo_feedback_controller"
application.register("turbo-feedback", TurboFeedbackController)

import LetterNumberPresetsController from "./letter_number_presets_controller"
application.register("letter-number-presets", LetterNumberPresetsController)
